import Image from '@atlaskit/image';
import breadcrumbsParts from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-parts.png";
import breadcrumbsPartsDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-parts-dark.png";
import breadcrumbsSizeDo from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-size-do.png";
import breadcrumbsSizeDoDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-size-do-dark.png";
import breadcrumbsSizeDont from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-size-dont.png";
import breadcrumbsSizeDontDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-size-dont-dark.png";
import breadcrumbsCurrentItemDo from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-current-item-do.png";
import breadcrumbsCurrentItemDoDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-current-item-do-dark.png";
import breadcrumbsCurrentItemDont from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-current-item-dont.png";
import breadcrumbsCurrentItemDontDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-current-item-dont-dark.png";
import breadcrumbsIconsDo from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-icons-do.png";
import breadcrumbsIconsDoDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-icons-do-dark.png";
import breadcrumbsIconsDont from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-icons-dont.png";
import breadcrumbsIconsDontDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-icons-dont-dark.png";
import breadcrumbsLabelsDo from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-distinguishable-labels-do.png";
import breadcrumbsLabelsDoDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-distinguishable-labels-do-dark.png";
import breadcrumbsLabelsDont from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-distinguishable-labels-dont.png";
import breadcrumbsLabelsDontDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-distinguishable-labels-dont-dark.png";
import breadcrumbsOverflow from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-overflow.png";
import breadcrumbsOverflowDark from "../../../../../../packages/design-system/breadcrumbs/constellation/images/breadcrumbs-overflow-dark.png";
import * as React from 'react';
export default {
  Image,
  breadcrumbsParts,
  breadcrumbsPartsDark,
  breadcrumbsSizeDo,
  breadcrumbsSizeDoDark,
  breadcrumbsSizeDont,
  breadcrumbsSizeDontDark,
  breadcrumbsCurrentItemDo,
  breadcrumbsCurrentItemDoDark,
  breadcrumbsCurrentItemDont,
  breadcrumbsCurrentItemDontDark,
  breadcrumbsIconsDo,
  breadcrumbsIconsDoDark,
  breadcrumbsIconsDont,
  breadcrumbsIconsDontDark,
  breadcrumbsLabelsDo,
  breadcrumbsLabelsDoDark,
  breadcrumbsLabelsDont,
  breadcrumbsLabelsDontDark,
  breadcrumbsOverflow,
  breadcrumbsOverflowDark,
  React
};